import { Module } from '../../ts/Module';
import { IServerSettingsFormScope, ServerSettingsFormCtrl } from '../controllers/ServerSettingsFormCtrl';

Module.instance().directive('tbServerSettingsForm',
  () => {
    return {
      restrict: 'E',
      replace: true,
      require: '^tbSettingsCoordinator',
      templateUrl: 'serverSettingsForm.html',
      link: ($scope: IServerSettingsFormScope,
        elm: JQuery,
        attrs: ng.IAttributes) => {
          $scope.sharedForm = $scope.sharedForm;
          $scope.localForm.formController = $scope.serverSettingsForm;
          $scope.sharedForm.registerFormStateByName($scope.localForm, 'serverSettingsForm');
      },
      controller: ServerSettingsFormCtrl
    };
  }
);
